import * as bi from 'react-bootstrap-icons';
import { Button, Flex, Input, Message, TextContent } from 'components';
import { useState } from 'react';
import { isValidEmail } from '../../../../helpers';

interface IProps {
  onLoginClick: (email: string) => void;
}

function FrameEmail(props: IProps) {
  const [email, setEmail] = useState<string>('');

  const isError = !isValidEmail(email.trim());

  const handleEnterKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !isError) {
      props.onLoginClick(email.trim());
    }
  };

  const handleLoginClick = () => {
    if (!isError) {
      props.onLoginClick(email.trim());
    }
  };

  return (
    <Flex
      direction='column'
      gap={20}
    >
      <TextContent align='center'>
        Введите адрес электронной почты, на который вы зарегистрированы в сервисе
      </TextContent>
      <Flex
        direction='column'
        gap={10}
      >
        <Input
          type='email'
          icon={<bi.Envelope />}
          label='E-Mail адрес'
          placeholder='address@mail.ru'
          value={email}
          onChange={setEmail}
          error={email.length > 0 && isError}
          onKeyDown={handleEnterKeyDown}
        />
        {email.length > 0 && isError && <Message type='error'>E-Mail адрес указан неверно</Message>}
      </Flex>

      <Button
        color='red'
        disabled={isError}
        onClick={handleLoginClick}
      >
        Получить код
      </Button>
    </Flex>
  );
}

export default FrameEmail;
